import { Link } from "react-router-dom";
import { WorkspaceHeader } from "../components/layout/WorkspaceHeader";
import { ConnectionsManager } from "../components/account/ConnectionsManager";

export function ConnectionsSettingsPage() {
  return (
    <div className="mx-auto max-w-6xl space-y-6 py-4">
      <WorkspaceHeader
        compact
        eyebrow="Account"
        title="Connections"
        description="Manage reusable publishing identities at the account level, then assign them to the brands that should publish with them."
        breadcrumbs={[
          { label: "Workspace", href: "/home" },
          { label: "Account settings", href: "/settings" },
          { label: "Connections" },
        ]}
        headingActions={(
          <Link
            to="/settings"
            className="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
          >
            Back to account settings
          </Link>
        )}
      />

      <ConnectionsManager />
    </div>
  );
}
